// extracted by mini-css-extract-plugin
export default {"root":"ranked_thumbnail_root__XTTXn","image":"ranked_thumbnail_image__na2Yi"};